export default __webpack_public_path__ + "assets/models/51825e1c39b5d08e318696583967aedc.glb";